import urlParser from 'bloko/common/urlParser';

import fetcher from 'src/utils/fetcher';

const URL = '/resumesavedsearch/save';

declare global {
    interface FetcherPostApi {
        [URL]: {
            queryParams: unknown;
            body: null;
            response: unknown;
        };
    }
}

const createSearchSubscription = (query: string): Promise<unknown> => {
    const params = urlParser(`?${query}`).params;

    return fetcher.post<typeof URL>(URL, null, { params });
};

export default createSearchSubscription;
